import { useEffect, useState } from 'react'

/**
 * The hook implements the logic for debounce a value and return it with a given delay.
 */
export function useDebounce<T>(value: T, delay: number): T
export function useDebounce<T>(
  value: T,
  delay: number,
  defaultValue: T | null
): T | null
export function useDebounce<T>(
  value: T,
  delay: number,
  defaultValue?: T | null
): T | null {
  const [debouncedValue, setDebouncedValue] = useState<T | null>(
    defaultValue !== undefined ? defaultValue : value
  )

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)
    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}
